import { Container, Section } from '@radix-ui/themes'
import { Outlet } from 'react-router-dom'

export const ApiKeys = () => {
  return (
    <Container>
      <Section size="1">
        <Outlet />
      </Section>
    </Container>
  )
}
